let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("23MlT")).then(() => parcelRequire('1yiQ2'));